import { css, htmlArray } from "../helpers/webComponents";
import { Page } from "../enums/Page";
import { GameEventService } from "../services/GameEventService";
import { RegisterService } from "../services/RegisterService";
import { PlayerService } from "../services/PlayerService";

const styles: string = css`
   .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
}

body {
    background-size: cover;
    background-position: center;
    filter: brightness(0.3); /* Nog donkerder contrast */
    color: #fff;
    font-family: 'Press Start 2P', cursive;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    margin: 0;
}

.container {
    background-color: rgba(30, 30, 30, 0.9); /* Donkerder transparant */
    border: 4px solid #555;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.8);
    text-align: center;
    width: 400px;
    height: auto;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}


h1 {
    font-size: 24px;
    margin-bottom: 20px;
}

label {
    font-size: 16px;
    margin-bottom: 8px;
    display: block;
}

input[type="text"], input[type="password"] {
    width: calc(100% - 20px); /* Zorgt voor even ruimte links en rechts */
    padding: 12px;
    margin: 8px 0;
    border: 2px solid #555;
    border-radius: 8px;
    background-color: #333;
    color: #fff;
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
    box-sizing: border-box; /* Houdt padding en border in de breedteberekening */
}


input[type="text"]:focus, input[type="password"]:focus {
    outline: none;
    border-color: #777;
}

button {
    width: 100%;
    padding: 12px;
    background-color: #555;
    color: #fff;
    border: 2px solid #777;
    border-radius: 8px;
    cursor: pointer;
    font-family: 'Press Start 2P', cursive;
    font-size: 16px;
}

button:hover {
    background-color: #777;
}

`;

export class RegisterComponent extends HTMLElement {
    private readonly _registerService: RegisterService = new RegisterService();
    private readonly _gameEventService: GameEventService = new GameEventService();
    private readonly _playerService: PlayerService = new PlayerService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();

        //  Checkbox-eventlistener goed geplaatst
        const togglePassword: HTMLInputElement = this.shadowRoot?.querySelector("#togglePassword") as HTMLInputElement;
        const pw: HTMLInputElement = this.shadowRoot?.querySelector("#password") as HTMLInputElement;
        const confirm: HTMLInputElement = this.shadowRoot?.querySelector("#confirmPassword") as HTMLInputElement;

        togglePassword.addEventListener("change", () => {
            const type: "text" | "password" = togglePassword.checked ? "text" : "password";
            pw.type = type;
            confirm.type = type;
        });

        // Registreer-button event
        const submitButton: HTMLButtonElement = this.shadowRoot?.querySelector("#submit") as HTMLButtonElement;
        submitButton.addEventListener("click", event => {
            event.preventDefault();
            void this.handleRegister();
        });
    }

    private async handleRegister(): Promise<void> {
        const username: string = (this.shadowRoot?.querySelector("#username") as HTMLInputElement).value;
        const password: string = (this.shadowRoot?.querySelector("#password") as HTMLInputElement).value;
        const confirmPassword: string = (this.shadowRoot?.querySelector("#confirmPassword") as HTMLInputElement).value;
        console.log("[RegisterComponent] Form data:", {
            username,
            password,
            confirmPassword,
            playerSessionId: this._playerService.getPlayerSessionId(),
        });

        if (password !== confirmPassword) {
            this.showMessage("Wachtwoorden komen niet overeen.", false);
            return;
        }

        if (!username || !password) {
            this.showMessage("Vul alle velden in.", false);
            return;
        }

        if (username.length < 3) {
            this.showMessage("Gebruikersnaam moet minimaal 3 tekens bevatten.", false);
            return;
        }

        if (password.length < 8) {
            this.showMessage("Wachtwoord moet minimaal 8 tekens bevatten.", false);
            return;
        }

        const playerSessionId: string = this._playerService.getPlayerSessionId();

        const result: {
            success: boolean;
            sessionId?: string;
            error?: string;

        } = await this._registerService.register(username, password, playerSessionId);
        console.log("[RegisterComponent] RegisterService response:", result);

        if (result.success && result.sessionId) {
            console.log("[RegisterComponent] Registratie succesvol!");

            localStorage.setItem("user", JSON.stringify({ username }));
            localStorage.setItem("playerSessionId", result.sessionId);

            this.showMessage("Registratie succesvol!", true);
            this._gameEventService.switchPage(Page.Canvas);
        }
        else {
            console.warn("[RegisterComponent] Registratie mislukt, niets opslaan in localStorage");

            localStorage.removeItem("user");
            localStorage.removeItem("playerSessionId");

            this.showMessage(result.error || "Registratie mislukt.", false);
        }
    }

    private showMessage(message: string, success: boolean): void {
        const messageDiv: HTMLDivElement = this.shadowRoot?.querySelector("#message") as HTMLDivElement;
        messageDiv.textContent = message;
        messageDiv.style.color = success ? "lightgreen" : "red";
    }

    private render(): void {
        const elements: HTMLElement[] = htmlArray`
    <style>${styles}</style>
    <img src="/assets/img/rooms/HomePage.png" class="bg">
    <div class="container">
        <h1>Registreren</h1>
        <div id="message" class="message"></div>
        <label for="username">Username</label>
        <input type="text" id="username" placeholder="Voer je gebruikersnaam in">
        
        <label for="password">Wachtwoord</label>
        <input type="password" id="password" placeholder="Minimaal 8 tekens">
        
        <label for="confirmPassword">Bevestig wachtwoord</label>
        <input type="password" id="confirmPassword" placeholder="Herhaal je wachtwoord">

        <div style="text-align: left; margin: 10px 0;">
            <input type="checkbox" id="togglePassword">
            <label for="togglePassword" style="font-size: 14px;">Wachtwoord tonen</label>
        </div>

        <button id="submit">Registreer</button>
    </div>
`;

        this.shadowRoot!.innerHTML = "";
        this.shadowRoot!.append(...elements);
    }
}
